import invariant from 'tiny-invariant';
import { TokenAmount } from '../amounts';
import { TradeType } from '../constants/constants';
import { BaseTrade } from '../types';
import { ZeroExLimitOrder } from './zero-ex-limit-order';

export class Trade0xLimit extends BaseTrade {
  private readonly _verifyingContract: string;
  private readonly _duration: number;
  private readonly _takerTokenFeeAmount?: TokenAmount;
  private readonly _feeRecipient?: string;

  constructor(inputAmount: TokenAmount, outputAmount: TokenAmount, duration: number, verifyingContract: string, takerTokenFeeAmount?: TokenAmount, feeRecipient?: string) {
    invariant(!inputAmount.currency.equals(outputAmount.currency), "AMOUNT'S TOKENS IS EQUAL");
    invariant(inputAmount.currency.isToken, 'Only tokens amount is supported (inputAmount).');
    invariant(outputAmount.currency.isToken, 'Only tokens amount is supported (outputAmount).');
    invariant(inputAmount.greaterThan('0') && outputAmount.greaterThan('0'), 'Both amounts should by greater than zero.');
    invariant(duration > 0, 'Duration should be greater than zero');

    super(TradeType.LIMIT, inputAmount, outputAmount);

    this._verifyingContract = verifyingContract;
    this._duration = duration;
    this._takerTokenFeeAmount = takerTokenFeeAmount;
    this._feeRecipient = feeRecipient;
  }

  /**
   * Returns limit order lifetime in seconds
   */
  public getOrderDuration(): number {
    return this._duration;
  }

  /**
   * Returns order finish timestamp (From current moment)
   */
  public getOrderEstimate(): number {
    return Math.floor(Date.now() / 1000) + this._duration;
  }

  /**
   * Construct new limit order
   * @param account
   */
  public getOrder(account: string): ZeroExLimitOrder {
    return new ZeroExLimitOrder(
      account,
      this.inputAmount as TokenAmount,
      this.outputAmount as TokenAmount,
      this.getOrderEstimate(),
      this._verifyingContract,
      this._takerTokenFeeAmount,
      this._feeRecipient,
    );
  }
}
